var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVege(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.681 3.96752L14.32 3.03352L12.937 3.56852L14.42 1.27152L13.58 0.728516C13.567 0.762516 11.252 4.30752 11.256 4.34152C10.009 3.35852 8.42999 3.33852 7.28299 4.35352C4.14599 7.12452 1.38499 11.8275 1.32499 13.7335C1.28899 14.5275 1.75999 14.9815 2.53799 14.9465C4.44399 14.8865 9.14699 12.1265 11.918 8.98952C12.93 7.84352 12.913 6.27352 11.939 5.02752L14.681 3.96752ZM11.168 8.32752C8.11099 11.7905 3.12099 14.2285 2.33899 13.9325C2.16299 13.4665 2.93099 11.5685 4.29199 9.45852L5.88099 11.0465L6.58799 10.3395L4.86199 8.61452C5.19999 8.13552 5.56299 7.65652 5.95199 7.18752L8.17399 9.40852L8.88098 8.70152L6.60799 6.42952C7.76399 5.08852 9.23599 3.66852 10.913 5.35952C11.841 6.28752 11.941 7.45352 11.168 8.32852V8.32752Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVege);
export default __webpack_public_path__ + "static/media/ico_vege.c8d47836744156d4fd891c2abce069e9.svg";
export { ForwardRef as ReactComponent };